import { useState, useEffect, useRef } from "react";
import { FaSpinner } from 'react-icons/fa';
import api from '../../../../Axios.js';
import { toastConfirm } from '../../../../utils/toastConfirm.jsx';
import { toast } from "react-toastify";
import * as XLSX from 'xlsx';
import { defaultDateFormatter, modalStyle, modalContentStyle } from "../../../../Helper/functionHelper.js";
import { CustomSelect } from '../../../../Helper/functionHelper.js';
import useAuthUser from "../../../../hooks/useAuthUser.js";


const AssetMakerSupport = () => {

    const { loggedInUser } = useAuthUser();
    const userRole = Number(loggedInUser?.role);

    const [assetMakerSupports, setAssetMakerSupports] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [assetMakers, setAssetMakers] = useState([]);

    const [errorsForm, setErrorsForm] = useState({});

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [assetMakerSupportFormData, setAssetMakerSupportFormData] = useState({
        asset_maker_id: null,
        contacts: '',
        emails: '',
        address: '',
        remarks: '',
        status: 1,
        _id: null,
    });



    const [filteredAssetMakerSupports, setFilteredAssetMakerSupports] = useState([]);
    const [filterForm, setFilterForm] = useState({
        searchQuery: '',
        status: '',
    });
    const handleChangeFilter = (e) => {
        const { name, value } = e.target;
        setFilterForm({ ...filterForm, [name]: value });
    };
    useEffect(() => {
        const result = assetMakerSupports.filter(item => {
            const status = item.status ?? '';

            const searchQuery = item.asset_maker_id.maker_name?.toLowerCase() +
                item.contacts?.toLowerCase() +
                item.emails?.toLowerCase() +
                item.address?.toLowerCase() +
                item.remarks?.toLowerCase();


            const matchesStatus =
                filterForm.status === '' || status === Number(filterForm.status);

            const matchesQuery =
                !filterForm.searchQuery ||
                searchQuery.toLowerCase().includes(filterForm.searchQuery.toLowerCase());

            return matchesStatus && matchesQuery;
        });

        setFilteredAssetMakerSupports(result);
    }, [filterForm, assetMakerSupports]);
    useEffect(() => {
        setCurrentPage(1);
    }, [filterForm, itemsPerPage]);



    useEffect(() => {
        fetchAssetMakerSupports();
    }, []);

    useEffect(() => {
        if (modalData) {
            setAssetMakerSupportFormData({
                asset_maker_id: modalData.asset_maker_id?._id || null,
                contacts: modalData.contacts || '',
                emails: modalData.emails || '',
                address: modalData.address || '',
                remarks: modalData.remarks || '',
                status: modalData.status ?? 1,
                _id: modalData._id || null,
            });
            setModalVisible(true);
        }
    }, [modalData]);

    const fetchAssetMakerSupports = async () => {
        try {
            const res = await api.get('/asset-maker-supports');
            setAssetMakerSupports(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchAssetMakers = async () => {
        try {
            const res = await api.get('/asset-makers');
            setAssetMakers(res.data.data);
        } catch (err) {
            console.error(err)
        }
    }

    const deleteAssetMakerSupport = (_id) => {
        toastConfirm({
            message: "Do you really want to delete this support?",
            onConfirm: async () => {
                try {
                    await api.delete(`/asset-maker-supports/${_id}`);
                    toast.success("Support deleted successfully!");
                    fetchAssetMakerSupports();
                } catch (err) {
                    toast.error("Failed to delete!");
                }
            },
        });
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredAssetMakerSupports.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredAssetMakerSupports.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const exportToExcel = () => {
        const exportData = filteredAssetMakerSupports.map(item => ({
            "Asset Maker": item.asset_maker_id.maker_name,
            "Contacts": item.contacts,
            "Emails": item.emails,
            "Address": item.address,
            "Remarks": item.remarks,
            "Status": item.status ? 'Active' : 'In-Active',
            "Created By": item.created_by_name,
            "Created At": defaultDateFormatter(item.created_at),
            "Updated By": item.updated_by_name,
            "Updated At": defaultDateFormatter(item.updated_at),
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Support/Vendors Details");

        XLSX.writeFile(workbook, `Support/Vendors Details Exported - ${new Date().toLocaleDateString()}.xlsx`);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrorsForm({ ...errorsForm, [name]: '' });
        setAssetMakerSupportFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            // validate errors here
            const newErrors = {};
            if (!assetMakerSupportFormData.asset_maker_id) newErrors.asset_maker_id = 'Maker Name is required';
            // Validate Contacts
            if (!assetMakerSupportFormData.contacts?.trim()) {
                newErrors.contacts = 'Contact Numbers are required';
            } else {
                const contactArray = assetMakerSupportFormData.contacts.split(',').map(c => c.trim()).filter(Boolean);
                const contactRegex = /^[6-9]\d{9}$/; // Indian mobile number format
                const invalidContacts = contactArray.filter(contact => !contactRegex.test(contact));
                if (invalidContacts.length > 0) {
                    newErrors.contacts = `Invalid contact(s): ${invalidContacts.join(', ')}`;
                }
            }
            // Validate Emails
            if (!assetMakerSupportFormData.emails?.trim()) {
                newErrors.emails = 'Email is required';
            } else {
                const emailArray = assetMakerSupportFormData.emails.split(',').map(e => e.trim()).filter(Boolean);
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emailArray.filter(email => !emailRegex.test(email));
                if (invalidEmails.length > 0) {
                    newErrors.emails = `Invalid email(s): ${invalidEmails.join(', ')}`;
                }
            }
            setErrorsForm(newErrors);
            if (Object.keys(newErrors).length === 0) {
                if (assetMakerSupportFormData._id) {
                    await api.patch(`/asset-maker-supports/${assetMakerSupportFormData._id}`, assetMakerSupportFormData);
                    toast.success("Support/Vendors Details updated!");
                } else {
                    await api.post(`/asset-maker-supports`, assetMakerSupportFormData);
                    toast.success("Support/Vendors Details created!");
                }
                setModalVisible(false);
                fetchAssetMakerSupports();
            }
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    // for import
    const [showImportBox, setShowImportBox] = useState(false);
    const [importBtnLabel, setImportBtnLabel] = useState('Import valid data');
    const fileInputRef = useRef(null);
    const importBoxRef = useRef(null);
    const importButtonRef = useRef(null);
    const [excelData, setExcelData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (modalData !== null)
            fetchAssetMakers();
    }, [modalData]);

    const handleImportClick = () => {
        setShowImportBox((prev) => !prev);
        fetchAssetMakers();
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false, dateNF: "yyyy-mm-dd" });

            const [validData, validationErrors] = validateData(jsonData);
            setExcelData(validData);
            setErrors(validationErrors);
            setShowModal(true);

            // hide import popups
            setShowImportBox((prev) => !prev);

        };

        reader.readAsBinaryString(file);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                importBoxRef.current &&
                !importBoxRef.current.contains(event.target) &&
                importButtonRef.current &&
                !importButtonRef.current.contains(event.target)
            ) {
                setShowImportBox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const validateData = (data) => {
        const errors = [];

        const validData = data.map((row, index) => {
            const rowErrors = {};
            // 🔹 Validate Asset Maker
            if (!row.maker_name) {
                rowErrors.maker_name = "Maker Name is required";
            } else {
                const matchedMaker = assetMakers.find(
                    (maker) => maker.maker_name?.trim().toLowerCase() === row.maker_name.trim().toLowerCase()
                );

                if (!matchedMaker) {
                    rowErrors.maker_name = "Maker Name doesn't exist";
                } else if (matchedMaker.status === 0) {
                    rowErrors.maker_name = "Maker Name is inactive";
                }
            }

            if (!row.contacts) {
                rowErrors.contacts = "Contact numbers are required";
            } else {
                const contactList = row.contacts.split(",").map(c => c.trim());
                const invalidContacts = contactList.filter(
                    c => !/^[6-9]\d{9}$/.test(c) // basic Indian mobile validation
                );
                if (invalidContacts.length > 0) {
                    rowErrors.contacts = `Invalid contact numbers: ${invalidContacts.join(", ")}`;
                }
            }

            if (!row.emails) {
                rowErrors.emails = "Emails are required";
            } else {
                const emailList = row.emails.split(",").map(e => e.trim());
                const invalidEmails = emailList.filter(
                    e => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
                );
                if (invalidEmails.length > 0) {
                    rowErrors.emails = `Invalid emails: ${invalidEmails.join(", ")}`;
                }
            }


            // 🔹 Validate Status
            if (row.status && !['active', 'in-active'].includes(row.status.trim().toLowerCase())) {
                rowErrors.status = "Invalid status";
            }

            // 🔹 Push errors if any for this row
            if (Object.keys(rowErrors).length > 0) {
                errors.push({ row: index + 2, errors: rowErrors }); // Excel rows usually start at 2
            }

            return row;
        });

        return [data, errors];
    };


    const handleImport = async () => {
        try {
            setImportBtnLabel(<FaSpinner />);
            // const validRows = excelData.filter((_, i) => !errors.some(e => e.row === i + 2));

            // if(validRows) {
            //     toast.error('No valid data found', {
            //         position: "top-right",
            //         autoClose: 3000,
            //     });
            // }

            const result = await api.post(`/asset-maker-supports/import`, excelData, {
                headers: { 'Content-Type': 'application/json' }
            });
            setShowModal(false);
            setImportBtnLabel('Import valid data');
            toast.success(result.data.message);
            fetchAssetMakerSupports();
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    const handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_BUILD_PATH}/uploads/sample_vendor_support_import.xlsx`;
        link.download = 'sample_vendor_support_import.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div>

            {modalVisible && (
                <div className="modal show d-block fade" tabIndex="-1" aria-labelledby="addcustomersupportLabel"
                    aria-hidden="true" style={modalStyle} onClick={() => setModalVisible(false)}>
                    <div className="modal-dialog" role="document" style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{assetMakerSupportFormData._id ? 'Edit Support/Vendors Details' : 'Add Support/Vendors Details'}</h5>
                                <button data-bs-toggle="tooltip" data-bs-placement="right" id="closeModalButton" title="Close"
                                    type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setModalVisible(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="popup-form">
                                    <div className="popup-form-row form-row-full">
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Maker Name*</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="asset_maker_id"
                                                        value={assetMakerSupportFormData.asset_maker_id}
                                                        options={[
                                                            { value: '', label: '-- Select --' },
                                                            ...assetMakers.map(maker => ({
                                                                value: maker._id,
                                                                label: maker.maker_name
                                                            }))
                                                        ]}
                                                        onChange={handleChange}
                                                    />
                                                    {errorsForm.asset_maker_id && <div className="text-danger">{errorsForm.asset_maker_id}</div>}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Contact Number*</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="contacts" value={assetMakerSupportFormData.contacts} onChange={handleChange}
                                                        className="form-control" placeholder="Contact Numbers Comma(,) Seperated" />
                                                    {errorsForm.contacts && <div className="text-danger">{errorsForm.contacts}</div>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Support Email*</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="emails" value={assetMakerSupportFormData.emails} onChange={handleChange}
                                                        className="form-control" placeholder="Support Emails Comma(,) Seperated" />
                                                    {errorsForm.emails && <div className="text-danger">{errorsForm.emails}</div>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Address</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="address" value={assetMakerSupportFormData.address} onChange={handleChange} className="form-control"
                                                        placeholder="Address" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Remarks</div>
                                                <div className="form-info-content">
                                                    <input type="text" name="remarks" value={assetMakerSupportFormData.remarks} onChange={handleChange}
                                                        className="form-control" placeholder="Remark" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-info">
                                                <div className="form-info-label">Status</div>
                                                <div className="form-info-content">
                                                    <CustomSelect
                                                        name="status"
                                                        value={assetMakerSupportFormData.status}
                                                        options={[
                                                            { value: 1, label: 'Active' },
                                                            { value: 0, label: 'In-Active' },
                                                        ]}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-btn-flex">
                                                <button type="button" className="btn btn-success"
                                                    onClick={handleSave}>Save</button>
                                                <button type="button" className="btn btn-secondary" data-bs-toggle="tooltip"
                                                    data-bs-placement="right" onClick={() => {
                                                        setModalVisible(false);
                                                        setModalData(null);
                                                    }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* import modal */}
            {showModal && (
                <div style={modalStyle}>
                    <div style={modalContentStyle}>
                        <h4>Preview Excel Data</h4>
                        <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Maker Name</th>
                                        <th>Contact Numbers</th>
                                        <th>Support Emails</th>
                                        <th>Address</th>
                                        <th>Remarks</th>
                                        <th>Status</th>
                                        <th>Errors</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelData.map((row, idx) => {
                                        const rowError = errors.find(e => e.row === idx + 2);
                                        return (
                                            <tr key={idx} style={{ backgroundColor: rowError ? '#fdd' : '#dfd' }}>
                                                <td>{row.maker_name}</td>
                                                <td>{row.contacts}</td>
                                                <td>{row.emails}</td>
                                                <td>{row.address}</td>
                                                <td>{row.remarks}</td>
                                                <td>{row.status}</td>
                                                <td style={{ color: 'red' }}>
                                                    {rowError && rowError.errors ? (
                                                        <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                            {Object.values(rowError.errors).map((err, index) => (
                                                                <li key={index}>{err}</li>
                                                            ))}
                                                        </ul>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3">
                            <button className="btn btn-success btn-sm me-2" onClick={handleImport}>{importBtnLabel}</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}


            <div className="row mt-3">
                <div className="col-lg-12">
                    <h2>
                        Support/Vendors Details
                        <span className="edit float-end has-export">
                            {[1, 2, 8, 9].includes(userRole) && (
                                <span className="toggle-wrapper">
                                    <button
                                        type="button"
                                        id="importEmployees"
                                        className="btn btn-dark btn-sm"
                                        onClick={handleImportClick}
                                        ref={importButtonRef}
                                    >
                                        <span className="material-icons-outlined">file_download</span>
                                        <span className="text"> Import</span>
                                    </button>
                                    {showImportBox && (
                                        <div class="import-container me-2" style={{ "display": "block" }}>
                                            <div
                                                className="import-box import-section arrow-top"
                                                ref={importBoxRef}
                                                style={{ "display": "block" }}>
                                                <div className="upload-box" onClick={() => fileInputRef.current.click()}>
                                                    <h3 id="fileTrigger">
                                                        <span className="material-icons-outlined">file_download</span> Click here to import
                                                    </h3>
                                                    <div className="supported-files">Supported types: .xls and .csv</div>
                                                </div>

                                                <div className="form-info-content mt-3">
                                                    <input
                                                        className="form-control"
                                                        type="file"
                                                        accept=".xlsx, .xls"
                                                        ref={fileInputRef}
                                                        onClick={() => { fileInputRef.current.value = null; }}
                                                        onChange={handleFileChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <button
                                                        className="btn btn-success mt-2"
                                                        onClick={handleDownloadSample}
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download Excel Format
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </span>

                            )}
                            {/* Export button */}
                            <button
                                onClick={exportToExcel}
                                className="btn btn-success btn-sm ms-2"
                                disabled={filteredAssetMakerSupports.length === 0}
                                style={{
                                    padding: "4px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "inline-flex",
                                    alignItems: "center",
                                }}
                            >
                                <span
                                    className="icon"
                                    style={{
                                        fontSize: "15px",
                                        marginRight: "4px",
                                        position: "relative",
                                        top: "-1px",
                                    }}
                                >
                                    <img
                                        src={`${process.env.REACT_APP_PUBLIC_PATH}/images/icons/icon-export.svg`}
                                        style={{ height: "18px" }}
                                        alt="Export"
                                    />
                                </span>
                                <span className="text">Export</span>
                            </button>
                            {/* Add New Button */}
                            {[1, 2, 8, 9].includes(userRole) && (
                                <button title="Add New" className="btn add" onClick={() => { setModalData({}); setErrorsForm({}); }}>
                                    <span className="material-icons-outlined">add_box</span>
                                </button>
                            )}
                        </span>
                    </h2>
                </div>
            </div>

            {/* Filters */}
            <div className="row">
                <div className="col-sm-2">
                    <label>Items per page:</label>
                    <select className='form-control' onChange={(e) => setItemsPerPage(parseInt(e.target.value))}>
                        <option value="5" selected={itemsPerPage === 5}>5</option>
                        <option value="10" selected={itemsPerPage === 10}>10</option>
                        <option value="25" selected={itemsPerPage === 25}>25</option>
                        <option value="50" selected={itemsPerPage === 50}>50</option>
                        <option value="100" selected={itemsPerPage === 100}>100</option>
                    </select>
                </div>
                <div className="col-sm-5">
                    <label>&nbsp;</label>
                    <input
                        type="text"
                        name="searchQuery"
                        placeholder="Asset Maker / Contact / Email / Address / Remarks"
                        value={filterForm.searchQuery}
                        onChange={handleChangeFilter}
                        className='form-control'
                    />
                </div>
                <div className="col-sm-5">
                    <label>&nbsp;</label>
                    <CustomSelect
                        name="status"
                        value={filterForm.status}
                        options={[
                            { value: '', label: 'All' },
                            { value: 1, label: 'Active' },
                            { value: 0, label: 'In-Active' },
                        ]}
                        onChange={handleChangeFilter}
                        disabled={false}
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1100,  // apply zIndex to dropdown menu
                            }),
                        }}
                    />
                </div>
            </div>


            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="table-responsive tbl-fixed-header tbl-main">
                        <table id="lettertype-table" cellpadding="0" cellspacing="0" class="table table-col-freeze">
                            <thead>
                                <tr>
                                    <th>Make name</th>
                                    <th>Contact number</th>
                                    <th>Support email</th>
                                    <th>Address</th>
                                    <th>Remarks</th>
                                    <th>Status</th>
                                    <th class="last-col-freeze">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentData.map((maker, index) => (
                                    <tr key={index}>
                                        <td>{maker.asset_maker_id.maker_name}</td>
                                        <td>{maker.contacts}</td>
                                        <td>{maker.emails}</td>
                                        <td>{maker.address}</td>
                                        <td>{maker.remarks}</td>
                                        <td>{maker.status ? 'Active' : 'In-Active'}</td>
                                        <td class="last-col-freeze">
                                            <button title="Edit" className='btn btn-sm' onClick={() => setModalData(maker)}>
                                                <span className="material-icons-outlined">edit</span>
                                            </button>
                                            <button title="Delete" className="btn btn-sm" onClick={() => deleteAssetMakerSupport(maker._id)}>
                                                <span className="material-icons-outlined">delete</span>
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Pagination */}
            <div className="row align-items-center">
                <div className="col-sm-6 text-start">
                    {totalPages > 1 && (
                        <nav aria-label="Page navigation">
                            <ul className="pagination">

                                {/* First */}
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link btn btn-sm" onClick={() => paginate(1)}>
                                        ≪
                                    </button>
                                </li>

                                {/* Previous */}
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link btn btn-sm" onClick={() => paginate(currentPage - 1)}>
                                        ‹
                                    </button>
                                </li>

                                {/* Limited Page Numbers */}
                                {(() => {
                                    const pageNumbers = [];
                                    const maxVisible = 3; // Show only 3 pages at a time
                                    let start = Math.max(1, currentPage - 1);
                                    let end = Math.min(totalPages, start + maxVisible - 1);

                                    if (end - start < maxVisible - 1) {
                                        start = Math.max(1, end - maxVisible + 1);
                                    }

                                    for (let i = start; i <= end; i++) {
                                        pageNumbers.push(
                                            <li
                                                key={i}
                                                className={`page-item ${currentPage === i ? "active" : ""}`}
                                            >
                                                <button className="page-link btn btn-sm" onClick={() => paginate(i)}>
                                                    {i}
                                                </button>
                                            </li>
                                        );
                                    }

                                    return pageNumbers;
                                })()}

                                {/* Next */}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button className="page-link btn btn-sm" onClick={() => paginate(currentPage + 1)}>
                                        ›
                                    </button>
                                </li>

                                {/* Last */}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button className="page-link btn btn-sm" onClick={() => paginate(totalPages)}>
                                        ≫
                                    </button>
                                </li>

                            </ul>
                        </nav>
                    )}
                </div>

                <div className="col-sm-6 text-end">
                    Showing {filteredAssetMakerSupports.length > indexOfFirstItem ? indexOfFirstItem + 1 : 0}
                    {" "}to{" "}
                    {filteredAssetMakerSupports.length > indexOfLastItem ? indexOfLastItem : filteredAssetMakerSupports.length}
                    {" "}of {filteredAssetMakerSupports.length} ({totalPages} Pages)
                </div>
            </div>


        </div>
    );
}

export default AssetMakerSupport;